import { render, staticRenderFns } from "./DetalheComponent.vue?vue&type=template&id=450d92e2"
import script from "./DetalheComponent.vue?vue&type=script&lang=js"
export * from "./DetalheComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports